import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


// Fix "Continue Shopping" button dynamically every time cart updates
function fixContinueButton() {
  const continueBtn = document.querySelector('a[href*="request-a-quote"]');
  if (continueBtn) {
    continueBtn.href = '/checkout'; // Go to Shopify checkout
    continueBtn.textContent = 'Continue to Checkout'; // Optional: change text
    continueBtn.removeAttribute('onclick'); // Remove old click behavior
    continueBtn.id = 'checkoutBtn'; // Optional: rename button
  }
}

// Run once on page load
document.addEventListener('DOMContentLoaded', fixContinueButton);

// Also run every time the cart updates (important for Shopify cart drawer)
document.addEventListener('cart:updated', fixContinueButton);